import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ITEMS_PER_PAGE = 10;

const Pagination = ({ currentPage, totalItems, onPageChange, itemsPerPage = ITEMS_PER_PAGE }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    if (totalPages <= 1) return null;

    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <div className="flex items-center justify-between px-4 py-3 border-t border-stone-200">
            <span className="text-sm text-stone-500">
                Showing {startItem}–{endItem} of {totalItems}
            </span>
            <div className="flex items-center gap-1">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage <= 1}
                    className="h-8 w-8 p-0"
                >
                    <ChevronLeft size={16} />
                </Button>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                    .reduce((acc, p, i, arr) => {
                        if (i > 0 && p - arr[i - 1] > 1) acc.push('...');
                        acc.push(p);
                        return acc;
                    }, [])
                    .map((p, i) =>
                        p === '...' ? (
                            <span key={`dot-${i}`} className="px-1 text-stone-400">…</span>
                        ) : (
                            <Button
                                key={p}
                                variant={p === currentPage ? 'default' : 'outline'}
                                size="sm"
                                onClick={() => onPageChange(p)}
                                className={`h-8 w-8 p-0 ${p === currentPage ? 'bg-[hsl(145,60%,20%)] text-white' : ''}`}
                            >
                                {p}
                            </Button>
                        )
                    )}
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                    className="h-8 w-8 p-0"
                >
                    <ChevronRight size={16} />
                </Button>
            </div>
        </div>
    );
};

export { Pagination, ITEMS_PER_PAGE };
export default Pagination;
